export const authClerkAppearance = {
  variables: {
    colorPrimary: '#0E5A4A',
    colorText: '#18181B',
    colorTextSecondary: '#52525B',
    colorBackground: '#FFFFFF',
    colorInputBackground: '#FFFFFF',
    colorInputText: '#18181B',
    borderRadius: '0.75rem',
    fontFamily: 'var(--font-sans), system-ui, sans-serif',
  },
  elements: {
    rootBox: 'mx-auto w-full max-w-xs lg:max-w-[25rem]',
    cardBox: 'w-full border-0 bg-transparent shadow-none',
    card: 'w-full border-0 bg-transparent p-0 shadow-none',
    header: 'mb-6 text-left',
    headerTitle: 'text-2xl/8 font-bold tracking-normal text-text-primary sm:text-xl/8',
    headerSubtitle: 'mt-1 text-base/7 text-text-secondary sm:text-sm/6',
    socialButtonsBlockButton:
      'h-12 rounded-xl border border-border-subtle bg-white text-base font-bold text-text-primary shadow-none hover:bg-neutral-50 sm:h-10 sm:text-sm',
    socialButtonsBlockButtonText: 'text-base font-bold sm:text-sm',
    dividerLine: 'bg-border-subtle',
    dividerText: 'px-2 text-sm text-text-tertiary',
    form: 'space-y-4',
    formField: 'space-y-1.5',
    formFieldLabel: 'text-base/6 font-medium text-text-primary sm:text-sm/6',
    formFieldInput:
      'h-12 rounded-xl border border-border-subtle bg-white px-3 text-base text-text-primary shadow-none outline-none focus:border-brand-700 focus:ring-[3px] focus:ring-brand-200/60 sm:h-10 sm:text-sm',
    formFieldInputShowPasswordButton: 'text-text-secondary hover:text-text-primary',
    formFieldAction: 'text-sm font-bold text-brand-700 hover:text-brand-800',
    formButtonPrimary:
      'h-12 rounded-xl bg-brand-700 text-base font-bold text-white shadow-none hover:bg-brand-800 focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2 sm:h-10 sm:text-sm',
    footer: 'mt-6',
    footerActionText: 'text-base/7 text-text-secondary sm:text-sm/6',
    footerActionLink: 'font-bold text-brand-700 hover:text-brand-800',
    identityPreview: 'rounded-xl border border-border-subtle bg-white shadow-none',
    identityPreviewText: 'text-base text-text-primary sm:text-sm',
    identityPreviewEditButton: 'font-bold text-brand-700 hover:text-brand-800',
    alert: 'rounded-xl border border-error-border bg-white text-error-text',
    formFieldErrorText: 'text-sm text-error-text',
  },
} as const;
